import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M2.38 22.73 22.11 3.01l-1.27-1.28-2.95 2.95a9.95 9.95 0 0 0-6.05-2.06c-5.5 0-10 4.5-10 10 0 2.28.77 4.37 2.06 6.05l-2.79 2.79 1.27 1.27m1.46-10.11c0-4.42 3.58-8 8-8 1.73 0 3.32.56 4.62 1.5L5.34 17.24a7.78 7.78 0 0 1-1.5-4.62m15.03-3.83 1.47-1.45c.94 1.53 1.5 3.34 1.5 5.28 0 5.5-4.5 10-10 10-1.94 0-3.75-.56-5.28-1.5l1.45-1.47c1.14.62 2.44.97 3.83.97 4.42 0 8-3.58 8-8 0-1.39-.35-2.69-.97-3.83z" }, null, -1)
  ])))
}
export default { render: render }